import React, { FC } from 'react';
import { SaveQuantityReportingConfigError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { SaveQuantityReportingErrorProps, SaveQuantityReportingConfigErrorExt } from './types';
import { FooterButtonStyled } from '~/styled';

const getErrorMessage = (error: SaveQuantityReportingErrorProps['saveQtyReportingConfigError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case SaveQuantityReportingConfigError.NOT_FOUND:
      return <Trans>Config Detail not found.</Trans>;
    case SaveQuantityReportingConfigError.INVALID_DAY_VALUE_SPECIFIED:
      return <Trans>Invalid Week Start/End Day.</Trans>;
    case SaveQuantityReportingConfigError.INVALID_TIME_VALUE_SPECIFIED:
      return <Trans>Invalid Week Start/End Time.</Trans>;
    case SaveQuantityReportingConfigErrorExt.WEEK_START_END_DAY_EQUAL:
      return <Trans>Start Work Week Day and End Work Work Day cannot have same values.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const SaveQuantityReportingError: FC<SaveQuantityReportingErrorProps> = ({ saveQtyReportingConfigError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="qty-config-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Quantity Reporting Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(saveQtyReportingConfigError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default SaveQuantityReportingError;
